import { render, staticRenderFns } from "./WapTopSweiper.vue?vue&type=template&id=60237ff4&scoped=true&"
import script from "./WapTopSweiper.vue?vue&type=script&lang=js&"
export * from "./WapTopSweiper.vue?vue&type=script&lang=js&"
import style0 from "./WapTopSweiper.vue?vue&type=style&index=0&id=60237ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60237ff4",
  null
  
)

export default component.exports